export function canCopyProjectToAccount({
  hasCopyProjectProduct,
  hasDuplicateStreamPermission,
  hasOtherAccounts,
}: {
  hasCopyProjectProduct: boolean;
  hasDuplicateStreamPermission: boolean;
  hasOtherAccounts: boolean;
}): boolean {
  return (
    hasDuplicateStreamPermission && hasOtherAccounts && hasCopyProjectProduct
  );
}
